<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_equipe">Equipe</label>
      </div>
      <select id="classement_equipe"
              v-model="dataForm.equipe_id"
              class="custom-select"
              name="classement_equipe">
        <option :key="equipe.equipe_id"
                :value="equipe.equipe_id"
                v-for="equipe in equipes">
          {{ equipe.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_matchs_joues_j">Matchs Joués (J)</label>
      </div>
      <input id="classement_matchs_joues_j"
             v-model="dataForm.matchs_joues_j"
             class="form-control"
             name="classement_matchs_joues_j"
             placeholder="Entrez le nombre de matchs joués"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_matchs_gagnes_g">Matchs Gagnés (G)</label>
      </div>
      <input id="classement_matchs_gagnes_g"
             v-model="dataForm.matchs_gagnes_g"
             class="form-control"
             name="classement_matchs_gagnes_g"
             placeholder="Entrez le nombre de matchs gagnés"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_matchs_perdus_p">Matchs Perdus (P)</label>
      </div>
      <input id="classement_matchs_perdus_p"
             v-model="dataForm.matchs_perdus_p"
             class="form-control"
             name="classement_matchs_perdus_p"
             placeholder="Entrez le nombre de matchs perdus"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_matchs_nulles_n">Matchs Nulles (N)</label>
      </div>
      <input id="classement_matchs_nulles_n"
             v-model="dataForm.matchs_nulles_n"
             class="form-control"
             name="classement_matchs_nulles_n"
             placeholder="Entrez le nombre de matchs nulles"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_buts_marques_gp">Buts Marqués (GP)</label>
      </div>
      <input id="classement_buts_marques_gp"
             v-model="dataForm.buts_marques_gp"
             class="form-control"
             name="classement_buts_marques_gp"
             placeholder="Entrez le nombre de buts marqués"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_buts_encaisses_gc">Buts Encaissés (GC)</label>
      </div>
      <input id="classement_buts_encaisses_gc"
             v-model="dataForm.buts_encaisses_gc"
             class="form-control"
             name="classement_buts_encaisses_gc"
             placeholder="Entrez le nombre de buts encaissés"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_points_pts">Points (PTS)</label>
      </div>
      <input id="classement_points_pts"
             v-model="dataForm.points_pts"
             class="form-control"
             name="classement_points_pts"
             placeholder="Entrez le nombre de points"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_difference_buts_gd">Différence des buts (GD)</label>
      </div>
      <input id="classement_difference_buts_gd"
             v-model="dataForm.difference_buts_gd"
             class="form-control"
             name="classement_difference_buts_gd"
             placeholder="Entrez la différence des buts"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_saison">Saison</label>
      </div>
      <select id="classement_saison"
              v-model="dataForm.saison_id"
              class="custom-select"
              name="classement_saison">
        <option :key="saison.saison_id"
                :value="saison.saison_id"
                v-for="saison in saisons">
          {{ saison.annee_debut }} - {{ saison.annee_fin  }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_championnat">Championnat</label>
      </div>
      <select id="classement_championnat"
              v-model="dataForm.championnat_id"
              class="custom-select"
              name="classement_championnat">
        <option :key="championnat.championnat_id"
                :value="championnat.championnat_id"
                v-for="championnat in championnats">
          {{ championnat.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="classement_position">Position</label>
      </div>
      <input id="classement_position"
             v-model="dataForm.position"
             class="form-control"
             name="classement_position"
             placeholder="Entrez la position de l'équipe dans le classement"
             type="number">
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Create",
  props: {},
  data() {
    return {
      championnats: null,
      saisons: null,
      equipes: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        equipe_id: '',
        matchs_joues_j: '',
        matchs_gagnes_g: '',
        matchs_perdus_p: '',
        matchs_nulles_n: '',
        buts_marques_gp: '',
        buts_encaisses_gc: '',
        points_pts: '',
        difference_buts_gd: '',
        saison_id: '',
        championnat_id: '',
        position: '',
        table: 'classements',
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPostData',
    ]),
    onSubmit() {
      this.axiosPostData(this.dataForm)
          .then((data) => {
            if((data.data.status === 'reussite' && data.status) === 201)
              this.messageSuccess = "Classement ajouté avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de l'insertion du classement !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de l'insertion du classement !"
          })
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    //
    this.axiosGetAllData({
      table: 'championnats'
    })
        .then((data) => {
          this.championnats = data.data
        })
        .catch((data) => {
          this.championnats = data
        })
    //
    this.axiosGetAllData({
      table: 'saisons'
    })
        .then((data) => {
          this.saisons = data.data
        })
        .catch((data) => {
          this.saisons = data
        })
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classements/components/Create.vue